import { render, staticRenderFns } from "./DkSlider.vue?vue&type=template&id=c4384afa&"
import script from "./DkSlider.vue?vue&type=script&lang=js&"
export * from "./DkSlider.vue?vue&type=script&lang=js&"
import style0 from "@v4/common/components/molecules/DkSlider/_index.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports